import produce from "immer";
import { DashboardActions } from ".";
import {
  FETCH_MECHANIC_COMPLAINTS,
  FETCH_USER_TRANSACTIONS_BY_DATE,
  FETCH_SOW_MECHANIC_LIST_PROGRESS,
  FETCH_SOW_MECHANIC_LIST_SUCCESS,
  FETCH_SOW_MECHANIC_LIST_FAILED,
  FETCH_SOW_MECHANIC_DASHBOARD_ANALYTICS_PROGRESS,
  FETCH_SOW_MECHANIC_DASHBOARD_ANALYTICS_SUCCESS,
  FETCH_SOW_MECHANIC_DASHBOARD_ANALYTICS_FAILED,
  CLEAR_SOW_MECHANIC_ANALYTICS,
} from "../constants";
import { IStoreState } from "../initialStoreState";
import { initialSowDashboard } from "./types";
import { LoadState } from "../../constants/enums";

export const sowDashboardReducer = (
  state: IStoreState["sowDashboard"] = initialSowDashboard,
  action: DashboardActions
) => {
  switch (action.type) {
    case FETCH_USER_TRANSACTIONS_BY_DATE: {
      const { key, list, count } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.sowUserTransactions.transactionsByDate[key] = {
          count: count,
          list: list,
        };
      });
      return newState;
    }
    case FETCH_MECHANIC_COMPLAINTS: {
      const { key, list, count } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.complaints.compaintsByDate[key] = {
          count: count,
          list: list,
        };
      });
      return newState;
    }
    case FETCH_SOW_MECHANIC_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.sowMechanicComplaint.loading = LoadState.InProgress;
      });
      return newState;
    }
    case FETCH_SOW_MECHANIC_LIST_SUCCESS: {
      const { list, totalRecords, records, amount } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.sowMechanicComplaint.list = list;
        draftState.sowMechanicComplaint.totalRecords = totalRecords;
        draftState.sowMechanicComplaint.loading = LoadState.Loaded;
        draftState.sowMechanicComplaint.amount = amount;
        draftState.sowMechanicComplaint.records = records;
      });
      return newState;
    }
    case FETCH_SOW_MECHANIC_LIST_FAILED: {
      const { error } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.sowMechanicComplaint.loading = LoadState.Failed;
        draftState.sowMechanicComplaint.error = error;
      });
      return newState;
    }
    case FETCH_SOW_MECHANIC_DASHBOARD_ANALYTICS_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.sowAnalytics.loading = LoadState.InProgress;
      });
      return newState;
    }
    case FETCH_SOW_MECHANIC_DASHBOARD_ANALYTICS_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.sowAnalytics.data = data;
        draftState.sowAnalytics.loading = LoadState.Loaded;
      });
      return newState;
    }
    case FETCH_SOW_MECHANIC_DASHBOARD_ANALYTICS_FAILED: {
      const { error } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.sowAnalytics.loading = LoadState.Failed;
        draftState.sowAnalytics.error = error;
      });
      return newState;
    }
    case CLEAR_SOW_MECHANIC_ANALYTICS: {
      const newState = produce(state, (draftState) => {
        draftState.sowAnalytics.data = initialSowDashboard.sowAnalytics.data;
        draftState.sowAnalytics.loading = LoadState.NotLoaded;
        draftState.sowAnalytics.error = null;
      });
      return newState;
    }

    default:
      return state;
  }
};
